import { render, staticRenderFns } from "./RuleItem.vue?vue&type=template&id=ad09c23e&scoped=true"
import script from "./RuleItem.vue?vue&type=script&lang=js"
export * from "./RuleItem.vue?vue&type=script&lang=js"
import style0 from "./RuleItem.vue?vue&type=style&index=0&id=ad09c23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad09c23e",
  null
  
)

export default component.exports